import { Box } from "@mui/material";

import classes from "./BackGeneral.module.css";

const BackGeneral = (props) => {
    const { children, colorBg } = props;

    return (
        <Box className={classes.background} bgcolor={colorBg ?? "#fff"}>
            {children}
        </Box>
    );
};

export default BackGeneral;
